module.exports = __webpack_public_path__ + "static/FY_2021_Investor_call_Dial-in information-0ca11e442521f3a55aaf9e2282fe40fa.pdf";